import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  uploadButtonContainer: {
    display: "flex",
    flexDirection: "column",
  },
}));
